package com.tixforgigs.common.ui.components.mandarin

import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.ui.components.icons.Icon
import io.kvision.core.Container
import io.kvision.event.clickFlow
import io.kvision.material.button.filledButton
import io.kvision.material.icon.icon
import io.kvision.material.iconbutton.filledIconButton
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach


fun Container.buttonsPanel(
  init: (SimplePanel.() -> Unit)? = null
  ): SimplePanel = simplePanel(
  className = "xm-buttons",
  init = init
  )


fun Container.mandarinFilledButton(
  title: String,
  isEnabled: StateFlow<Boolean> = MutableStateFlow(true),
  iconName: Icon? = null,
  onClick: suspend () -> Unit = {}
) {
  filledButton(className = "xm-button") {
    text = title
    iconName?.let { icon(it.value) }
  }.bind(isEnabled) { inputsValid ->
    disabled = inputsValid.not()
  }.clickFlow.onEach {
    onClick()
  }.launchIn(AppScope)
}

fun Container.mandarinFilledIconButton(
  iconName: Icon,
  isEnabled: StateFlow<Boolean> = MutableStateFlow(true),
  onClick: suspend () -> Unit = {}
) {
  filledIconButton {
    icon(iconName.value)
  }.bind(isEnabled) { enabled ->
    disabled = enabled.not()
  }.clickFlow.onEach {
    onClick()
  }.launchIn(AppScope)
}